

<template>
  <app-box-header  v-if="!isPackFlight" :title="$t('shared.payment_method')">
    <p>
      {{$t("step.choose_payment_method")}}
    </p>
    <div class="flex flex-col lg:flex-row justify-center items-center lg:space-x-4 mt-6 mx-auto">
      <div
        @click="paymentMethod = 'redsys'"
        class="w-full md:w-4/5 lg:w-full payment-container"
      >
        <app-box-booking :class="{ selected: paymentMethod === 'redsys' }">
          <img class="check" src="/img/icons/blue-check.svg" />
          <div class="payment-method-item payment-method-item--stripe">
            <div class="img-container">
              <img class="visa" src="/img/brands/visa-2.svg" alt="Visa" />
              <img
                class="mastercard"
                src="/img/brands/mastercard.svg"
                alt="Mastercard"
              />
              <img
                class="maestro"
                src="/img/brands/maestro.png"
                alt="Maestro"
              />
              <img
                class="american-express"
                src="/img/brands/american-express.png"
                alt="American Express"
              />
            </div>
            <p class="text-center mt-3 mb-1">{{$t("step.credit_or_debit")}}</p>
          </div>
        </app-box-booking>
      </div>

      <div
        @click="paymentMethod = 'paypal'"
        class="w-full md:w-4/5 lg:w-full payment-container"
      >
        <app-box-booking :class="{ selected: paymentMethod === 'paypal' }">
          <img class="check" src="/img/icons/blue-check.svg" />
          <div class="payment-method-item payment-method-item--paypal">
            <div class="img-container">
              <img class="paypal" src="/img/brands/paypal.svg" alt="Paypal" />
            </div>
            <p class="text-center mt-3 mb-1">Paypal</p>
          </div>
        </app-box-booking>
      </div>
    </div>
    <transition name="slide-fade">
      <redsys-component
        ref="redsysComponent"
        :gift="gift"
        :nights="nights"
        :extras="extras"
      ></redsys-component>
    </transition>
  </app-box-header>

  <div v-else>
    <div class="flex justify-start items-center space-x-4 mt-6">
      <div
        @click="paymentMethod = 'redsys'"
        class="w-full payment-container"
      >
        <app-box-booking class="rounded" :class="{ selected: paymentMethod === 'redsys' }">
            <img class="check" src="/img/icons/blue-check.svg" />
            <div class="payment-method-item">
              <div class="img-container flex items-center gap-4">
                <img class="visa" src="/img/brands/visa-2.svg" alt="Visa" />
                <img class="maestro" src="/img/brands/maestro.png" alt="Maestro" />
                <img class="mastercard" src="/img/brands/mastercard.svg" alt="Mastercard" />
              </div>
            </div>
        </app-box-booking>
      </div>
    </div>
    <transition name="slide-fade">
      <redsys-component
        ref="redsysComponent"
        :gift="gift"
        :nights="nights"
        :extras="extras"
      ></redsys-component>
    </transition>
  </div>
</template>

<script>
import { GET_PAYMENT_METHOD } from "../../../../../../../store/getter-types";
import { SET_PAYMENT_METHOD } from "../../../../../../../store/mutation-types";
import { NIGHTS_GET_IS_PACK_FLIGHT } from "../../../../../../../store/nights/getter-types";
import { mapGetters } from "vuex";
import StripeComponent from "../../../../../../../components/Payment/StripeComponent.vue";

export default {
  props: {
    gift: {
      type: Boolean,
      default: false,
    },
    nights: {
      type: Boolean,
      default: false,
    },
    extras: {
      type: Boolean,
      default: false
    }
  },
  components: {
    StripeComponent,
  },
  computed: {
    ...mapGetters({
      isPackFlight: NIGHTS_GET_IS_PACK_FLIGHT,
    }),
    paymentMethod: {
      get() {
        return this.$store.getters[GET_PAYMENT_METHOD];
      },
      set(value) {
        this.$store.commit(SET_PAYMENT_METHOD, value);
      },
    },
  },
  created() {
    this.paymentMethod = 'redsys';
  }
};
</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/variables";


.booking-box {
  border-radius: 5px;
  position: relative;
  cursor: pointer;
  margin: 1rem 0;

  &.selected {
    border: 2px solid $turquoiseBlue;
    margin: -1px 0;

    .check {
      display: block;
    }
  }

  .check {
    display: none;
    position: absolute;
    bottom: -15px;
    left: 50%;
    transform: translateX(-50%);
  }
}

.payment-method-item {
  .img-container {
    img {
      + img {
        margin-left: 18px;
      }

      &.visa {
        height: 40px;
      }
      &.mastercard {
        height: 52px;
      }
      &.maestro,
      &.american-express {
        height: 44px;
      }
      &.paypal {
        height: 45px;
      }
    }
  }
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.4s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(1000px);
  opacity: 0;
}
</style>
